import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-ba1aee36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "routeDetail" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "routeWrapper" }

import { Skeletor } from 'vue-skeletor';
import { PortList, IconText, ServiceStatus } from '..';
import { ServiceStatusType } from '../../types/ServiceStatusType';
import { Port } from '../../types';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteDetail',
  props: {
    status: {},
    ports: {},
    destinationName: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(IconText), {
          text: _ctx.destinationName,
          "icon-name": "mapPin",
          "icon-md": true,
          "is-loading": _ctx.isLoading
        }, null, 8, ["text", "is-loading"]),
        _renderSlot(_ctx.$slots, "favourite")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.status && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(ServiceStatus), {
              key: 0,
              status: _ctx.status
            }, null, 8, ["status"]))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_unref(Skeletor), {
                key: 1,
                class: "vue-skeletor-status"
              }))
            : _createCommentVNode("", true),
        _createVNode(_unref(PortList), {
          ports: _ctx.ports,
          "show-port-code": true,
          "is-loading": _ctx.isLoading
        }, null, 8, ["ports", "is-loading"])
      ]),
      _renderSlot(_ctx.$slots, "lastUpdated"),
      _renderSlot(_ctx.$slots, "infoCard")
    ])
  ]))
}
}

})